import React, { useState } from 'react';
import { Globe, Bell, Shield, CreditCard, Mail, Server, Key, Database, Smartphone, CheckCircle2, Save, Plus, Trash2, Edit2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminSettingsFullManagerProps {
  success: (msg: string) => void;
}
export function AdminSettingsFullManager({
  success
}: AdminSettingsFullManagerProps) {
  const [notifSettings, setNotifSettings] = useState<Record<string, boolean>>({
    newOrders: true,
    newAstrologers: true,
    pushNotifications: false,
    weeklyDigest: true,
    systemErrors: true,
    paymentFailures: true
  });
  const [paymentSystems, setPaymentSystems] = useState([{
    name: 'Stripe',
    status: true,
    fee: '2.9% + 30¢'
  }, {
    name: 'PayPal',
    status: true,
    fee: '3.49% + 49¢'
  }, {
    name: 'CloudPayments',
    status: false,
    fee: '2.8%'
  }, {
    name: 'Crypto (USDT)',
    status: true,
    fee: '1%'
  }]);
  const [services, setServices] = useState([{
    id: 'SRV-001',
    name: 'Натальная карта (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 490 ₽',
    status: 'active'
  }, {
    id: 'SRV-002',
    name: 'Соляр на год (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 990 ₽',
    status: 'active'
  }, {
    id: 'SRV-003',
    name: 'Консультация (30 мин)',
    category: 'Консультации',
    type: 'Видео',
    price: 'от 3 000 ₽',
    status: 'active'
  }, {
    id: 'SRV-004',
    name: 'Базовый курс астрологии',
    category: 'Курсы',
    type: 'Видеокурс',
    price: '15 000 ₽',
    status: 'active'
  }]);
  const handleSave = () => {
    success('Настройки успешно сохранены');
  };
  const renderToggle = (label: string, checked: boolean, onChange: () => void, description?: string) => <div className="flex items-start justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6103">
      <div data-id="element-6104">
        <div className="text-sm font-medium text-slate-900" data-id="element-6105">{label}</div>
        {description && <div className="text-xs text-slate-500 mt-0.5" data-id="element-6106">{description}</div>}
      </div>
      <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ml-4 ${checked ? 'bg-indigo-500' : 'bg-slate-300'}`} onClick={onChange} data-id="element-6107">
        <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6108" />
      </button>
    </div>;
  const generalSettings = <div className="space-y-6 max-w-3xl" data-id="element-6109">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6110">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6111">
          <Globe className="w-4 h-4 text-indigo-500" data-id="element-6112" /> Основная информация
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6113">
          <Input label="Название платформы" defaultValue="Astriqo" data-id="element-6114" />
          <Input label="Основной домен" defaultValue="astriqo.com" data-id="element-6115" />
          <Input label="Email поддержки" defaultValue="support@astriqo.com" data-id="element-6116" />
          <Input label="Телефон поддержки" defaultValue="+7 (800) 555-35-35" data-id="element-6117" />
          <div className="md:col-span-2" data-id="element-6118">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6119">
              Язык по умолчанию
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6120">
              <option value="ru" data-id="element-6121">Русский (RU)</option>
              <option value="en" data-id="element-6122">English (EN)</option>
              <option value="es" data-id="element-6123">Español (ES)</option>
            </select>
          </div>
        </div>
      </Card>

      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6124">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6125">
          <Database className="w-4 h-4 text-indigo-500" data-id="element-6126" /> Локализация и форматы
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6127">
          <div data-id="element-6128">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6129">
              Основная валюта
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6130">
              <option value="RUB" data-id="element-6131">Российский рубль (₽)</option>
              <option value="USD" data-id="element-6132">Доллар США ($)</option>
              <option value="EUR" data-id="element-6133">Евро (€)</option>
            </select>
          </div>
          <div data-id="element-6134">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6135">
              Часовой пояс сервера
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6136">
              <option value="Europe/Moscow" data-id="element-6137">Europe/Moscow (UTC+3)</option>
              <option value="UTC" data-id="element-6138">UTC</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-6139">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6141" />} onClick={handleSave} data-id="element-6140">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const servicesSettings = <div className="space-y-6" data-id="element-6142">
      <div className="flex justify-between items-center" data-id="element-6143">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-6144">
          Управление услугами
        </h3>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6146" />} data-id="element-6145">
          Добавить услугу
        </Button>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6147">
        <table className="w-full text-left" data-id="element-6148">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6149">
            <tr data-id="element-6150">
              <th className="px-4 py-3 font-medium" data-id="element-6151">ID</th>
              <th className="px-4 py-3 font-medium" data-id="element-6152">Название</th>
              <th className="px-4 py-3 font-medium" data-id="element-6153">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-6154">Тип</th>
              <th className="px-4 py-3 font-medium" data-id="element-6155">Базовая цена</th>
              <th className="px-4 py-3 font-medium" data-id="element-6156">Статус</th>
              <th className="px-4 py-3 text-right font-medium" data-id="element-6157">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6158">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-6159">
                <td className="px-4 py-3 text-xs text-slate-500" data-id="element-6160">{s.id}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-6161">
                  {s.name}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6162">
                  {s.category}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6163">{s.type}</td>
                <td className="px-4 py-3 text-sm font-bold text-slate-900" data-id="element-6164">
                  {s.price}
                </td>
                <td className="px-4 py-3" data-id="element-6165">
                  <Badge variant={s.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-6166">
                    {s.status === 'active' ? 'Активна' : 'Скрыта'}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-right" data-id="element-6167">
                  <div className="flex justify-end gap-2" data-id="element-6168">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400" data-id="element-6170" />} data-id="element-6169" />
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400" data-id="element-6172" />} data-id="element-6171" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
  const paymentSettings = <div className="space-y-6 max-w-4xl" data-id="element-6173">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6174">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6175">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6176">
            <CreditCard className="w-4 h-4 text-indigo-500" data-id="element-6177" /> Платёжные шлюзы
          </h3>
          <div className="space-y-1" data-id="element-6178">
            {paymentSystems.map((p, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6179">
                <div data-id="element-6180">
                  <div className="text-sm font-medium text-slate-900" data-id="element-6181">
                    {p.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-6182">
                    Комиссия: {p.fee}
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-6183">
                  <Button variant="ghost" size="sm" className="text-xs h-7" data-id="element-6184">
                    Настроить
                  </Button>
                  <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ${p.status ? 'bg-emerald-500' : 'bg-slate-300'}`} onClick={() => {
                const newSystems = [...paymentSystems];
                newSystems[i].status = !newSystems[i].status;
                setPaymentSystems(newSystems);
                success(newSystems[i].status ? `${p.name} включен` : `${p.name} отключен`);
              }} data-id="element-6185">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${p.status ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6186" />
                  </button>
                </div>
              </div>)}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6187">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6188">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6189" /> Финансовые настройки
          </h3>
          <div className="space-y-4" data-id="element-6190">
            <Input label="Базовая комиссия платформы (%)" defaultValue="20" data-id="element-6191" />
            <Input label="Минимальная сумма вывода (₽)" defaultValue="5000" data-id="element-6192" />
            <Input label="Период холда средств (дней)" defaultValue="14" data-id="element-6193" />

            <div className="pt-4 border-t border-slate-100" data-id="element-6194">
              {renderToggle('Автоматические выплаты', false, () => {}, 'Выплаты астрологам 1 и 15 числа месяца')}
              {renderToggle('Разрешить возвраты клиентам', true, () => {}, 'В течение 24 часов после оплаты')}
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6195">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6197" />} onClick={handleSave} data-id="element-6196">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const emailSettings = <div className="space-y-6 max-w-4xl" data-id="element-6198">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6199">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6200">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6201">
            <Mail className="w-4 h-4 text-indigo-500" data-id="element-6202" /> SMTP Настройки
          </h3>
          <div className="space-y-4" data-id="element-6203">
            <Input label="SMTP Сервер" defaultValue="smtp.sendgrid.net" data-id="element-6204" />
            <div className="grid grid-cols-2 gap-4" data-id="element-6205">
              <Input label="Порт" defaultValue="587" data-id="element-6206" />
              <div data-id="element-6207">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6208">
                  Шифрование
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6209">
                  <option value="tls" data-id="element-6210">TLS</option>
                  <option value="ssl" data-id="element-6211">SSL</option>
                  <option value="none" data-id="element-6212">Нет</option>
                </select>
              </div>
            </div>
            <Input label="SMTP Логин" defaultValue="apikey" data-id="element-6213" />
            <Input label="SMTP Пароль" type="password" defaultValue="****************" data-id="element-6214" />
            <Input label="Отправитель (From Email)" defaultValue="noreply@astriqo.com" data-id="element-6215" />
            <Input label="Имя отправителя (From Name)" defaultValue="Astriqo" data-id="element-6216" />
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-6217">
              Отправить тестовое письмо
            </Button>
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6218">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6219">
            <Bell className="w-4 h-4 text-indigo-500" data-id="element-6220" /> Системные уведомления
          </h3>
          <div className="space-y-1" data-id="element-6221">
            {renderToggle('Уведомления о новых заказах', notifSettings.newOrders, () => setNotifSettings(p => ({
            ...p,
            newOrders: !p.newOrders
          })))}
            {renderToggle('Заявки на верификацию', notifSettings.newAstrologers, () => setNotifSettings(p => ({
            ...p,
            newAstrologers: !p.newAstrologers
          })))}
            {renderToggle('Ошибки системы (Критичные)', notifSettings.systemErrors, () => setNotifSettings(p => ({
            ...p,
            systemErrors: !p.systemErrors
          })))}
            {renderToggle('Ошибки платежей', notifSettings.paymentFailures, () => setNotifSettings(p => ({
            ...p,
            paymentFailures: !p.paymentFailures
          })))}
            {renderToggle('Еженедельный дайджест', notifSettings.weeklyDigest, () => setNotifSettings(p => ({
            ...p,
            weeklyDigest: !p.weeklyDigest
          })))}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6222">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6224" />} onClick={handleSave} data-id="element-6223">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const securitySettings = <div className="space-y-6 max-w-4xl" data-id="element-6225">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6226">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6227">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6228">
            <Shield className="w-4 h-4 text-indigo-500" data-id="element-6229" /> Политики безопасности
          </h3>
          <div className="space-y-1" data-id="element-6230">
            {renderToggle('Двухфакторная авторизация (2FA)', true, () => {}, 'Обязательно для всех администраторов')}
            {renderToggle('Логирование всех входов', true, () => {}, 'Сохранять IP и User-Agent')}
            {renderToggle('Защита от брутфорса', true, () => {}, 'Блокировка после 5 неудачных попыток')}
            {renderToggle('Принудительная смена пароля', false, () => {}, 'Каждые 90 дней')}
            {renderToggle('Ограничение сессий', true, () => {}, 'Не более 3 активных сессий на пользователя')}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6231">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6232">
            <Key className="w-4 h-4 text-indigo-500" data-id="element-6233" /> Ограничения доступа (IP)
          </h3>
          <div className="space-y-4" data-id="element-6234">
            <div data-id="element-6235">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6236">
                Белый список IP для админки
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500 min-h-[100px]" placeholder="Введите IP адреса по одному в строке..." defaultValue="192.168.1.1&#10;10.0.0.0/24" data-id="element-6237" />
              <p className="text-[10px] text-slate-500 mt-1" data-id="element-6238">
                Оставьте пустым для доступа с любого IP
              </p>
            </div>
            {renderToggle('Блокировать Tor/VPN', false, () => {})}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6239">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6241" />} onClick={handleSave} data-id="element-6240">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const apiSettings = <div className="space-y-6 max-w-4xl" data-id="element-6242">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6243">
        <div className="flex justify-between items-center mb-4" data-id="element-6244">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-6245">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6246" /> API Ключи
          </h3>
          <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6248" />} data-id="element-6247">
            Создать ключ
          </Button>
        </div>

        <div className="space-y-4" data-id="element-6249">
          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6250">
            <div className="flex justify-between items-start mb-2" data-id="element-6251">
              <div data-id="element-6252">
                <div className="text-sm font-bold text-slate-900" data-id="element-6253">
                  Mobile App API (Production)
                </div>
                <div className="text-xs text-slate-500" data-id="element-6254">
                  Создан: 12.05.2023 • Последнее использование: 5 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6255">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6256">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6257">
                sk_live_51Mxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6258">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6259">
                <Trash2 className="w-4 h-4" data-id="element-6260" />
              </Button>
            </div>
          </div>

          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6261">
            <div className="flex justify-between items-start mb-2" data-id="element-6262">
              <div data-id="element-6263">
                <div className="text-sm font-bold text-slate-900" data-id="element-6264">
                  OpenAI Integration Key
                </div>
                <div className="text-xs text-slate-500" data-id="element-6265">
                  Создан: 01.08.2023 • Последнее использование: 1 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6266">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6267">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6268">
                sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6269">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6270">
                <Trash2 className="w-4 h-4" data-id="element-6271" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-6272">
      <div data-id="element-6273">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-6274">
          Настройки платформы
        </h2>
        <p className="text-sm text-slate-500" data-id="element-6275">
          Глобальные параметры работы системы
        </p>
      </div>

      <Tabs tabs={[{
      id: 'general',
      label: 'Общие',
      content: generalSettings
    }, {
      id: 'services',
      label: 'Услуги',
      content: servicesSettings
    }, {
      id: 'payments',
      label: 'Платежи',
      content: paymentSettings
    }, {
      id: 'email',
      label: 'Email',
      content: emailSettings
    }, {
      id: 'security',
      label: 'Безопасность',
      content: securitySettings
    }, {
      id: 'api',
      label: 'API',
      content: apiSettings
    }]} data-id="element-6276" />
    </div>;
}